import './Login.scss';
import AuthPageLayout from '../AuthPageLayout';

import loginImage from '../../../assets/images/login-image.svg';
import subtractImage from '../../../assets/images/subtract.svg';
import { ReactComponent as GoogleIcon } from '../../../assets/images/google.svg';
import { ReactComponent as AppleIcon } from '../../../assets/images/apple.svg';
import { useContext, useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import Checkbox from '../../../component/input/Checkbox';
import Password from '../../../component/input/Password';
import InputText from '../../../component/input/InputText';
import LangSwitcher from '../../../component/langswitcher/LangSwitcher.jsx';
import { useTranslation } from 'react-i18next';
import useValidator from '../../../utils/validator/useValidator.js';
import { AuthService } from '../../../service/AuthService.js';
import { MessageContext } from '../../../context/MessageContext.jsx';
import { useLocation, useNavigate } from 'react-router-dom';
import StatusMessage from '../../../component/statusmessage/StatusMessage.jsx';
import { RenderedHelper } from '../../../utils/render/RenderedHelper.js';

const Login = ({ }) => {
    const [inProgress, setInProgress] = useState(false);
    const [rememberMe, setRememberMe] = useState(localStorage.getItem('rememberLogin') === 'true');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [mainKey, setMainKey] = useState(0);
    const [errorMessage, setErrorMessage] = useState(null);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const socialMediaEnabled = false;

    const validator = useValidator();
    

    useEffect(() => {
        const tryLogin = localStorage.getItem('rememberLogin') === 'true';
        const searchParams = new URLSearchParams(location.search);
        const force = searchParams.get("force") === "true";
        if (tryLogin && !force) {
            localStorage.setItem('auth', true);
            navigate('/')
        }

    }, []);

    useEffect(() => {
        localStorage.setItem('rememberLogin', rememberMe);
    }, [rememberMe]);

    const forceUpdate = () => {
        setMainKey(prev => prev + 1);
    }

    const showErrorMessage = (msg) => {
        setErrorMessage(msg)
    }

    const login = async () => {
        setErrorMessage(null);
        if (validator.allValid()) {
            try {
                setInProgress(true);            
                const result = await AuthService.login(email, password);
                console.log("Zalogowano:", result);
                localStorage.setItem('auth', 'true');
                navigate('/');

            } catch (err) {
                console.log("Błąd logowania", err);
                localStorage.removeItem('auth');
                setInProgress(false);
                if (err.invalidUserOrPassword) {
                    console.log(t('login.message.invalidEmailOrPassword'));
                    showErrorMessage(t('login.message.invalidEmailOrPassword'));
                } else if (err.accountDisabled) {
                    console.log(t('login.message.accountDisabled'));
                    showErrorMessage(t('login.message.accountDisabled'));
                } else if (err.accountTemporaryDisabled) {
                    console.log(t('login.message.accountTemporaryDisabled'));
                    showErrorMessage(t('login.message.accountTemporaryDisabled', { date: RenderedHelper.formatTimestamp(err.date) }));
                } else if (err.connectionError) {
                    console.log("Błąd połączenia z serwerem");
                    showErrorMessage(t('login.message.connectionError'));

                } else {
                    console.log("Nieznany błąd", err);
                    showErrorMessage(t('login.message.unknownError'));
                }
            }
        } else {
            console.log('validator', validator)
            validator.showMessages();
            forceUpdate();
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            login();
        }
    }

    return (
        <AuthPageLayout className='login-container'>
            <div className='mb-4'>
                <StatusMessage variant='danger' message={errorMessage} />
            </div>
            <div className='sign-in'>{t('login.pageTitle')}</div>
            <div className='login-prompt'>{t('login.pageDescription')}</div>
            <div className='mt-4'>
                <InputText id='email' label={t('login.email')} value={email} onChange={e => setEmail(e.target.value.trim())} validator={validator} validations={'email|required'} />
                <Password id='password' label={t('login.password')} value={password} onChange={e => setPassword(e.target.value)} validator={validator} validations={'required'} onKeyDown={handleKeyDown} />
            </div>
            <div className="flex align-items-center">
                <Checkbox label={t('login.rememberMe')} checked={rememberMe} onChange={e => setRememberMe(e.checked)} />
                <div className="ml-auto" style={{ height: '26px' }}>
                    <a className='forgot-password-link ' href='#' onClick={e => { e.preventDefault(); navigate('/auth/password-recovery'); }}>{t('login.forgotPassword')}</a>                    
                </div>
            </div>
            <div className='w-full mt-4'>
                <Button label={t('login.signIn')} className='w-full' loading={inProgress}
                    onClick={e => login()}
                />
            </div>
            {socialMediaEnabled && (
                <>
                    <div className='divider-container'>
                        <div className='line' />
                        <div className='text'>{t('login.or')}</div>
                        <div className='line' />
                    </div>
                    <div className='social-buttons' >
                        <Button icon={<GoogleIcon />} outlined className='w-full' />
                        <Button icon={<AppleIcon />} outlined className='w-full' />
                    </div>
                </>
            )}
        </AuthPageLayout>
    )
}

export default Login;